import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppLayout } from 'layouts/app-layout';
import { Router } from './router';
import { Worker } from '@react-pdf-viewer/core';
import { StructureCopyProvider } from 'store/stucture/provider';
import { DocumentCompareProvider } from 'store/document-compare';
import { FolderStructureUploadProvider } from 'views/structure-directory/context/folder-structure-upload-context';

export const App = () => {
    return (
        <BrowserRouter>
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                <StructureCopyProvider>
                    <DocumentCompareProvider>
                        <FolderStructureUploadProvider>
                            <AppLayout>
                                <Router />
                            </AppLayout>
                        </FolderStructureUploadProvider>
                    </DocumentCompareProvider>
                </StructureCopyProvider>
            </Worker>
        </BrowserRouter>
    );
};
